import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../../utils/api';

export interface ChangeOfCourseAuditLog {
  id: number;
  applicantId: string;
  changedBy: string;
  previousProgramId: number;
  newProgramId: number;
  previousConcentrationId: number | null;
  newConcentrationId: number | null;
  previousProgramTypeId: number | null;
  newProgramTypeId: number | null;
  reason: string;
  changedAt: string;
}

export interface ChangeOfCourseAuditLogResponse {
  code: number;
  message: string;
  data: ChangeOfCourseAuditLog[];
}

export const GET_CHANGE_OF_COURSE_AUDIT_LOG_QUERY_KEY = 'get-change-of-course-audit-log';

export const useGetChangeOfCourseAuditLogQuery = (applicantId?: string | number) => {
  const fetchChangeOfCourseAuditLog = async (): Promise<ChangeOfCourseAuditLogResponse> => {
    return (await api.get(`/StudentInfo/CourseChangeAudit/${applicantId}`))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<
    ChangeOfCourseAuditLogResponse,
    AxiosError<ApiErrorResponse>
  >({
    queryKey: [GET_CHANGE_OF_COURSE_AUDIT_LOG_QUERY_KEY, applicantId],
    queryFn: fetchChangeOfCourseAuditLog,
    enabled: Boolean(applicantId),
  });

  const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch change of course audit log';

  return {
    data,
    changeOfCourseAuditLogData: data?.data ?? [],
    isLoading,
    isChangeOfCourseAuditLogLoading: isLoading,
    isError,
    isChangeOfCourseAuditLogError: isError,
    errorMessage,
    changeOfCourseAuditLogErrorMessage: errorMessage,
    refetch,
  };
};
